// import betterfetch from 'better-fetch';
import { getConfig } from '@/select/Config';

export default {
  // components: {betterfetch},
  async fetch(url, options = {})
  {
    let config = await getConfig();
    //Get headers from options, or empty object if none set.
    var headers = options.headers || {};
    var method = options.method || 'GET';
    if (method !== 'GET')
    {
      // var csrf = await this.getCSRFToken().then((response) => response.json());
      // headers['X-CSRF-TOKEN'] = csrf._csrf;
      if (!headers[ 'Content-Type' ])
      {
        headers[ 'Content-Type' ] = 'application/json';
      }
      if (headers[ 'No-Content-Type' ] === true)
      {
        delete headers[ 'Content-Type' ];
        delete headers[ 'No-Content-Type' ];
      }
    }
    options.headers = headers;
    if (config.NODE_ENV.toUpperCase() == 'DEVELOPMENT')
    {
      console.log(url);
    }
    var promise = new Promise(((resolve, reject) =>
    {
      fetch(url, options)
        .catch(error =>
        {
          console.log('Select Fetch : error ');
          reject(error);
        })
        .then(response =>
        {
          console.log(response.status);
          if (response.status == 401)
          {
            reject('401 ERROR');
            if (!window.location.href.includes('/login'))
            {
              window.location.href = '/login';
            }
          }
          else
          {
            resolve(response);
          }
        })
        .catch(error =>
        {
          console.log('error decoding json' + error);
        });
    }));
    promise.then(async (response) =>
    {
      let clone = await response.clone();
      try
      {
        let data = clone.response.text();
        data = JSON.parse(data);
        data = _.filter(data, (val) =>
        {
          return Object.keys(_.flatMap(val)).length > 2;
        });
        response.json = function ()
        {
          return data;
        }
      }
      catch (exception)
      {
        console.log("Not JSON, ignoring.");
      }
    }, (error) =>
    { });
    return promise;
  },
  checkLoggedIn: function ()
  {
    var promise = new Promise((resolve, reject) =>
    {
      getConfig().then((config) =>
      {

        this.fetch(config.VUE_APP_BACKEND_ENDPOINT + 'users/profile', {
          credentials: 'include'
        })
          .then(response =>
          {
            if (response.ok)
            {
              console.log('Returned response : ');
              resolve('OK');
            }
            else
            {
              reject('ERROR');
            }
          })
          .catch(error =>
          {
            reject('ERROR');
          });
      })
    });
    promise.then((result) =>
    { }, (error) =>
    { });
    return promise;
  },
  getCSRFToken: function ()
  {
    var promise = new Promise((resolve, reject) =>
    {
      getConfig().then((config) =>
      {
        this.fetch(config.VUE_APP_BACKEND_ENDPOINT + 'csrfToken', {
          credentials: 'include'
        })
          .then(response =>
          {
            console.log('Returned response : ');
            resolve(response);
          })
          .catch(error =>
          {
            reject('ERROR');
          });
      })
    });
    promise.then((result) =>
    { }, (error) =>
    { });
    return promise;
  },
  serialise: function (obj)
  {
    var str = [];
    for (var p in obj)
    {
      if (obj.hasOwnProperty(p))
      {
        str.push(encodeURIComponent(p) + '='
          + encodeURIComponent(
            (typeof (obj[ p ]) === 'object' ? JSON.stringify(obj[ p ]) : obj[ p ])
          ));
      }
    }
    return str.join('&');
  },
  capitaliseFirst: function (string)
  {
    string = string.charAt(0).toUpperCase() + string.slice(1);
    return string;
  },

  async getPopups(passedKey)
  {
    let config = await getConfig();
    let returnResults = [];

    let results = await this.fetch(config.VUE_APP_BACKEND_ENDPOINT + 'popups/' + passedKey, { credentials: 'include' });
    if (results)
    {
      returnResults = await results.json();
    }

    return returnResults;
  },

  async getUsername()
  {
    let config = await getConfig();
    let returnUsername = '';
    let results = await this.fetch(config.VUE_APP_BACKEND_ENDPOINT + 'users/profile', { credentials: 'include' });

    if (results.ok)
    {
      let userData = await results.json();
      if (userData)
      {
        returnUsername = userData.username;
      }
    }
    return returnUsername;
  },

  async getUserGroup()
  {
    let config = await getConfig();
    let returnUserGroup = '';

    let results = await this.fetch(config.VUE_APP_BACKEND_ENDPOINT + 'users/profile', { credentials: 'include' });

    if (results.ok)
    {
      let userData = await results.json();
      if (userData)
      {
        returnUserGroup = userData.usergroup;
      }
    }

    return returnUserGroup;

  },

  async getUserProfile()
  {
    let config = await getConfig();
    let returnUserProfile = {};
    let results = await this.fetch(config.VUE_APP_BACKEND_ENDPOINT + 'users/profile', { credentials: 'include' });

    if (results.ok)
    {
      let userData = await results.json();
      if (userData)
      {
        returnUserProfile = userData;
      }
    }

    return returnUserProfile;
  },

  async systemLog(processDesc, info, supportingData)
  {

    let config = await getConfig();
    let returnValue = false;

    let params =
    {
      process: processDesc || '',
      info: info || '',
      supportingData: supportingData || ''
    };

    let result = await this.fetch(config.VUE_APP_BACKEND_ENDPOINT + 'systemlog',
      {
        credentials: 'include',
        method: 'PUT',
        headers:
        {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
      })

    if (result.ok)
    {
      if (result.status == 200)
      {
        returnValue == true;
      }
    }

    return returnValue;
  },

  async saveFormData(formData, savePath)
  {
    let response = null;

    if (!formData._id)
    {
      // add mode
      response = await this.fetch(
        savePath,
        {
          credentials: 'include',
          method: 'PUT',
          headers:
          {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }
      )
    }
    else
    {
      // edit mode
      response = await this.fetch(
        savePath,
        {
          credentials: 'include',
          method: 'PATCH',
          headers:
          {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }
      );
    }

    return response;
  },
  async deleteRecord(recordData, path)
  {
    let response = null;

    response = await this.fetch(
      path,
      {
        credentials: 'include',
        method: 'DELETE',
        headers:
        {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(recordData)
      }
    );

    return response;
  },

  async getDefaultVATRate(vatCode)
  {
    let returnValue = 0.00 ; 

    let response = await SelectFunctions.fetch(
      this.$root.$data.$env.VUE_APP_BACKEND_ENDPOINT + 
      `vatcodes/currentrate/${vatCode}`
    );

    if (response && response.ok)
    {
      try{
        let result = await response.json();
        returnValue = result.rate ; 
      }
      catch(e)
      {
        console.log('getDefaultVATRate : caught error : ', e);
      }
    }

    return returnValue ;
  }

};
